module.exports = __webpack_public_path__ + "img/五边形@2x.69282077.png";